import { makeAutoObservable } from 'mobx';

import { LoadedFile } from '../../interfaces/LoadedFile';
import {
  BILLING_TYPE,
  BillingType,
  BillingTypeFlags,
} from '../../constants/user-info/billingType';
import { getFlagsObject } from '../../utils/sortingAndGroupingUtil';
import { resetAllStore } from '../resetAllStore';
import { EntitySignUpData } from '../../interfaces/EntitySignUpData';

// Note: This store is used to store entity public data on sign-up flows (customer self setup to entity, scan iq)
class EntitySignUpStore {
  entityId: number | null = null;
  entityName: string | null = null;
  entityLogo: LoadedFile | null = null;
  billingTypeFlags: BillingTypeFlags = {};
  scanIqBillingTypeFlags: BillingTypeFlags = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.entityId = null;
    this.entityName = null;
    this.entityLogo = null;
    this.billingTypeFlags = {};
    this.scanIqBillingTypeFlags = {};
  }

  setEntityData(entityData: EntitySignUpData) {
    this.setEntityId(entityData.entityId);
    this.setEntityName(entityData.entityName);
    this.setEntityLogo(entityData.entityLogo);
    this.setBillingTypeFlags(entityData.billingType);
    this.setScanIqBillingTypeFlags(entityData.scanIqBillingType);
  }

  setEntityId(entityId: number) {
    this.entityId = entityId;
  }

  setEntityName(entityName: string) {
    this.entityName = entityName;
  }

  setEntityLogo(entityLogo: LoadedFile | null) {
    this.entityLogo = entityLogo;
  }

  setBillingTypeFlags(billingType: BillingType) {
    this.billingTypeFlags = getFlagsObject(BILLING_TYPE, [billingType]);
  }

  setScanIqBillingTypeFlags(scanIqBillingType: BillingType | null) {
    this.scanIqBillingTypeFlags = scanIqBillingType
      ? getFlagsObject(BILLING_TYPE, [scanIqBillingType])
      : {};
  }
}

const entitySignUpStore = new EntitySignUpStore();
resetAllStore.addResetMethod(entitySignUpStore.setDefaultValues);

export { entitySignUpStore, EntitySignUpStore };
